/** Sales application API — navegación, hooks, presentación y screen-hooks. */

export type { SaleDetailRouteParams, SalesListRouteParams } from './application/salesNavigation';
export type { BranchSalesHistoryCashierFilter } from './application/salesListRouteParams';
export type {
  SaleStatusFilter,
  SaleFiscalStatusFilter,
  SaleSortKey,
  SaleSortDir,
  SalesListScreenViewModel,
} from './application/useSalesListScreen';

export { openSaleDetail, openSalesList } from './application/salesNavigation';

export {
  formatSaleCreatedAt,
  formatSaleShortRefSuffix,
  formatSaleShortRefLabel,
  formatSaleDisplayRef,
  formatSaleKitchenNotes,
  formatSaleListItemsSummary,
  formatSaleListPaymentMethods,
  formatSalePendingLine,
  formatMercadoPagoPaymentDetail,
  formatInvoiceCaeLine,
  formatCashSessionLabel,
  resolveFiscalInvoiceDisplayStatus,
  resolveSalePaymentStatusPresentation,
  buildSaleListMinimalStatusChip,
  buildSaleStatusChips,
  spanishSaleStatusLabel,
  spanishPaymentStatusLabel,
  resolveSalePaymentLinePresentation,
  formatSaleChannelLabel,
  isOnlineSaleChannel,
} from './application/salePresentation';

export {
  summarizeSaleDetailDiscounts,
  summarizeSaleDetailLines,
  formatSaleDetailLinePromoHint,
  hasSaleDetailPromotions,
  type SaleDetailDiscountSummaryRow,
  type SaleDetailLineSummaryRow,
} from './application/saleDetailPromotionPresentation';

export { salesListParamsFromReportsScope } from './application/salesListParamsFromReports';

export { useBranchSalesHistory } from './application/useBranchSalesHistory';
export { useSalesListScreen } from './application/useSalesListScreen';
export { useSaleDetail } from './application/useSaleDetail';
export { useSaleCustomerCollect } from './application/useSaleCustomerCollect';

export { executeVoidSaleCommand } from './application/voidSaleCommand';

export { useSalesListForBranch } from './screen-hooks/useSalesListForBranch';
